import { z } from 'zod'

export const frameSequenceSchema = z.int().positive()
